import {
  GLOBAL_CREATE_GROUP_MODULE,
  GLOBAL_CREATE_ITEM_MODULE,
  SIDEBAR_MODULE_KEYS,
} from "./navigationCatalog";

/**
 * Empty or missing storage means every module is enabled.
 * @param {string[] | null | undefined} savedKeys
 * @returns {Set<string>}
 */
export function normalizeActiveModuleKeys(savedKeys) {
  if (!savedKeys?.length) {
    return new Set(SIDEBAR_MODULE_KEYS);
  }
  return new Set(savedKeys);
}

export function isModuleActive(activeKeys, moduleKey) {
  return activeKeys.has(moduleKey);
}

/**
 * @param {Array<{ key: string }>} catalog
 * @param {Set<string>} activeKeys
 */
export function filterSidebarCatalog(catalog, activeKeys) {
  return catalog.filter(entry => isModuleActive(activeKeys, entry.key));
}

function moduleForCreateItem(groupKey, itemKey) {
  return GLOBAL_CREATE_ITEM_MODULE[itemKey] ?? GLOBAL_CREATE_GROUP_MODULE[groupKey];
}

/**
 * @param {Array<{ key: string, children?: Array<{ key: string }> }>} catalog
 * @param {Set<string>} activeKeys
 */
export function filterGlobalCreateCatalog(catalog, activeKeys) {
  return catalog
    .map(group => {
      const groupModule = GLOBAL_CREATE_GROUP_MODULE[group.key];
      if (!groupModule) return null;
      const children = (group.children || []).filter(child =>
        isModuleActive(activeKeys, moduleForCreateItem(group.key, child.key)),
      );
      if (children.length === 0) return null;
      return { ...group, children };
    })
    .filter(Boolean);
}
